<template>
    <v-row class="pb-offset ma-0">
		<v-col class="pa-0">
            <v-card elevation="1" class="background-2 round-card">
                <v-card-title class="pa-3">
				    <p :class="{'pl-3': $vuetify.breakpoint.smAndUp, 'pl-2': $vuetify.breakpoint.smAndDown}">Impostazioni Generali Applicazione</p>
                    <v-spacer></v-spacer>
                </v-card-title>                
                <v-divider></v-divider>
                <v-container class="pa-0" fluid>
                    <v-row class="pa-4 ma-0">
                        <v-col class="pt-0 pb-2 px-4" cols="12">
                            <v-subheader class="pl-0 pb-0 pt-3">Dati Aziendali</v-subheader>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Ragione Sociale"
                                v-model="settings['business_name']"
                                :error-messages="errors.collect('Ragione Sociale')"
                                :data-vv-name="'Ragione Sociale'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="P. Iva"
                                v-model="settings['vat_number']"
                                :error-messages="errors.collect('P. Iva')"
                                v-validate="'digits:11'"
                                :data-vv-name="'P. Iva'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Codice Fiscale"
                                v-model="settings['fiscal_code']"
                                :error-messages="errors.collect('Codice Fiscale')"
                                :data-vv-name="'Codice Fiscale'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Telefono Primario"
                                v-model="settings['primary_telephone']"
                                :error-messages="errors.collect('Telefono Primario')"
                                :data-vv-name="'Telefono Primario'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>                        
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Indirizzo Email"
                                v-model="settings['primary_email']"
                                :error-messages="errors.collect('Indirizzo Email')"
                                v-validate="'email'"
                                :data-vv-name="'Indirizzo Email'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Website"
                                v-model="settings['primary_website']"
                                :error-messages="errors.collect('Website')"
                                v-validate="'url'"
                                :data-vv-name="'Website'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col class="pt-0 pb-2 px-4" cols="12">
                            <v-subheader class="pl-0 pb-0 pt-3">Indirizzo Operativo</v-subheader>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Via"
                                v-model="settings['address_street']"
                                :error-messages="errors.collect('Via')"
                                :data-vv-name="'Via'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Numero Civico"
                                v-model="settings['address_number']"
                                :error-messages="errors.collect('Numero Civico')"
                                :data-vv-name="'Numero Civico'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Codice Postale"
                                v-model="settings['address_zipcode']"
                                :error-messages="errors.collect('Codice Postale')"
                                v-validate="'digits:5'"
                                :data-vv-name="'Codice Postale'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Città"
                                v-model="settings['address_city']"
                                :error-messages="errors.collect('Città')"
                                :data-vv-name="'Città'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Provincia"
                                v-model="settings['address_province']"
                                :error-messages="errors.collect('Provincia')"
                                v-validate="'alpha|max:2|min:2'"
                                :data-vv-name="'Provincia'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Nazione"
                                v-model="settings['address_country']"
                                :error-messages="errors.collect('Nazione')"
                                v-validate="'alpha'"
                                :data-vv-name="'Nazione'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>

                        <template v-if="this.$store.getters.checkSettings('map')">
                            <v-col class="pt-0 pb-0 px-4 col-lg-3 col-md-3 col-sm-4 col-12">
                                <v-text-field
                                    type="text"
                                    label="Latitudine Indirizzo"
                                    v-model="settings['address_lat']"
                                    :error-messages="errors.collect('Latitudine Indirizzo')"
                                    v-validate="'decimal'"
                                    :data-vv-name="'Latitudine Indirizzo'"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col class="pt-0 pb-0 px-4 col-lg-3 col-md-3 col-sm-4 col-12">
                                <v-text-field
                                    type="text"
                                    label="Logintudine Indirizzo"
                                    v-model="settings['address_lng']"
                                    :error-messages="errors.collect('Logintudine Indirizzo')"
                                    v-validate="'decimal'"
                                    :data-vv-name="'Logintudine Indirizzo'"
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col class="pt-0 pb-0 px-4 col-lg-3 col-md-3 col-sm-4 col-12">
                                <v-btn type="text" outlined dense @click="localizePosition()" :disabled="!canLocalize">
                                    Localizza Posizione
                                    <v-icon right dark>my_location</v-icon>
                                </v-btn>
                            </v-col>
                        </template>

                        <v-col class="pt-0 pb-2 px-4" cols="12">
                            <v-subheader class="pl-0 pb-0 pt-3">Indirizzo Legale</v-subheader>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Via (Indirizzo Legale)"
                                v-model="settings['legal_address_street']"
                                :error-messages="errors.collect('Via (Indirizzo Legale)')"
                                :data-vv-name="'Via (Indirizzo Legale)'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Numero Civico (Indirizzo Legale)"
                                v-model="settings['legal_address_number']"
                                :error-messages="errors.collect('Numero Civico (Indirizzo Legale)')"
                                :data-vv-name="'Numero Civico (Indirizzo Legale)'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Codice Postale (Indirizzo Legale)"
                                v-model="settings['legal_address_zipcode']"
                                :error-messages="errors.collect('Codice Postale (Indirizzo Legale)')"
                                v-validate="'digits:5'"
                                :data-vv-name="'Codice Postale (Indirizzo Legale)'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Città (Indirizzo Legale)"
                                v-model="settings['legal_address_city']"
                                :error-messages="errors.collect('Città (Indirizzo Legale)')"
                                :data-vv-name="'Città (Indirizzo Legale)'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Provincia (Indirizzo Legale)"
                                v-model="settings['legal_address_province']"
                                :error-messages="errors.collect('Provincia (Indirizzo Legale)')"
                                v-validate="'alpha|max:2|min:2'"
                                :data-vv-name="'Provincia (Indirizzo Legale)'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Nazione (Indirizzo Legale)"
                                v-model="settings['legal_address_country']"
                                :error-messages="errors.collect('Nazione (Indirizzo Legale)')"
                                v-validate="'alpha'"
                                :data-vv-name="'Nazione (Indirizzo Legale)'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col class="pt-0 pb-2 px-4" cols="12">
                            <v-subheader class="pl-0 pb-0 pt-3">Dati Bancari</v-subheader>
                        </v-col>                        
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Banca"
                                v-model="settings['bank']"
                                :error-messages="errors.collect('Banca')"
                                :data-vv-name="'Banca'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="IBAN"
                                v-model="settings['iban']"
                                :error-messages="errors.collect('IBAN')"
                                v-validate="'alpha_num'"
                                :data-vv-name="'IBAN'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col class="pt-0 pb-2 px-4" cols="12">
                            <v-subheader class="pl-0 pb-0 pt-3">Dati per la Fatturazione</v-subheader>
                        </v-col>

                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                label="Codice destinatario"
                                v-model="settings['recipient_code']"
                                :error-messages="errors.collect('Codice destinatario')"
                                :data-vv-name="'Codice destinatario'"
                                v-validate="'alpha_num|min:6|max:7'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="email"
                                label="PEC"
                                v-model="settings['pec_email']"
                                :error-messages="errors.collect('PEC')"
                                v-validate="'email'"
                                :data-vv-name="'PEC'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-select
                                label="Regime Fiscale"
                                :items="regimi"
                                v-model="settings['regime_fiscale']"
                                :menu-props="{'offset-y': true}"
                                outlined
                                dense
                            ></v-select>
                        </v-col>

                        <v-col class="pt-0 pb-2 px-4" cols="12" sm="12" v-if="settings.logo">
                            <file-uploader class="pa-1" 
                                :id="settings.logo"
                                :attachable-type="'setting'"
                                :field="{'label': 'Logo per Documenti'}"
                                :options="{'maxFiles': 1}"
                            ></file-uploader>
                        </v-col> 

                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                        </v-col>
                        
                        <v-col class="pt-0 pb-2 px-4" cols="12">
                            <v-subheader class="pl-0 pb-0 pt-3">Impostazioni Tema</v-subheader>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6">
                            <v-text-field
                                type="text"
                                label="Nome Applicazione"
                                v-model="settings['app_name']"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4 text-center" cols="12" sm="12">
                            <v-color-picker
                                v-model="settings['app_color']"
                                hide-canvas
                                show-swatches
                                width="100%"
                                class="pb-6 background-2"
                                flat
                                swatches-max-height="250px"
                            ></v-color-picker>	
                            <v-btn color="primary" @click="settings['app_color'] = '#ffc107'">Default</v-btn>
                        </v-col>

                        <v-col class="pt-0 pb-2 px-4" cols="12">
                            <v-subheader class="pl-0 pb-0 pt-3">Logo Applicazione</v-subheader>
                        </v-col>
                        <image-input v-model="settings.app_logo" class="pl-4" :max-width="450" :max-heigth="450">
                            <div slot="activator" class="pa-2" style="border-radius: 50% !important; border: 2px solid #ececec;">
                                <v-avatar :size="120" v-ripple v-if="!settings.app_logo" class="grey lighten-3 cursor-pointer">
                                    <v-icon :size="60">mdi-domain</v-icon>
                                </v-avatar>
                                <v-avatar v-else
                                    :size="120" 
                                    v-ripple
                                    class="custom-avatar cursor-pointer"
                                    :style="{'background-image': 'url(' + settings.app_logo + ')'}">
                                </v-avatar>
                            </div>
                        </image-input>
                    </v-row>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions class="pr-4 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native="saveSettings('reload')">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>

    import FileUploader from '@/components/common/FileUploader'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin';

    export default {
        name: 'settings-options',
        mixins: [SettingsOptionsMixin],
        components: {
            FileUploader
        },
        props: {},
        data() {
            return {
                file: {},
                model: 'settings',
                settings: {
                    'model': 'settings',
                    'business_name': '',
                    'address_street': '',
                    'address_number': '',
                    'address_zipcode': '',
                    'address_city': '',
                    'address_country': '',
                    'address_province': '',
                    'address_lat': '',
                    'address_lng': '',
                    'vat_number': '',
                    'primary_email': '',
                    'primary_website': '',
                    'bank': '',
                    'iban': '',
                    'logo': '',
                    'recipient_code': '',
                    'pec_email': '',
                    'app_color': '#ffc107',
                    'app_name': '',
                    'app_logo': ''
                },
                regimi: [
                    {'value': "RF01", 'text': "Ordinario"},
                    {'value': "RF02", 'text': "Contribuenti minimi (art.1, c.96-117, L. 244/07) "},
                    {'value': "RF04", 'text': "Agricoltura e attività connesse e pesca (artt.34 e 34-bis, DPR 633/72) "},
                    {'value': "RF05", 'text': "Vendita sali e tabacchi (art.74, c.1, DPR. 633/72) "},
                    {'value': "RF06", 'text': "Commercio fiammiferi (art.74, c.1, DPR  633/72) "},
                    {'value': "RF07", 'text': "Editoria (art.74, c.1, DPR  633/72)"},
                    {'value': "RF08", 'text': "Gestione servizi telefonia pubblica (art.74, c.1, DPR 633/72) "},
                    {'value': "RF09", 'text': "Rivendita documenti di trasporto pubblico e di sosta (art.74, c.1, DPR  633/72) "},
                    {'value': "RF10", 'text': "Intrattenimenti, giochi e altre attività di cui alla tariffa allegata al DPR 640/72 (art.74, c.6, DPR 633/72) "},
                    {'value': "RF11", 'text': "Agenzie viaggi e turismo (art.74-ter, DPR 633/72) "},
                    {'value': "RF12", 'text': "Agriturismo (art.5, c.2, L. 413/91) "},
                    {'value': "RF13", 'text': "Vendite a domicilio (art.25-bis, c.6, DPR  600/73) "},
                    {'value': "RF14", 'text': "Rivendita beni usati, oggetti d’arte, d’antiquariato o da collezione (art.36, DL 41/95) "},
                    {'value': "RF15", 'text': "Agenzie di vendite all’asta di oggetti d’arte, antiquariato o da collezione (art.40-bis, DL 41/95) "},
                    {'value': "RF16", 'text': "IVA per cassa P.A. (art.6, c.5, DPR 633/72) "},
                    {'value': "RF17", 'text': "IVA per cassa (art. 32-bis, DL 83/2012) "},
                    {'value': "RF18", 'text': "Altro"},
                    {'value': "RF19", 'text': "Regime forfettario (art.1, c.54-89, L. 190/2014)"},
                    {'value': "RF20", 'text': "Regime transfrontaliero di Franchigia IVA (Direttiva UE 2020/285)"},
                ]
            }
        },

        computed: {
            canLocalize() {
                return (this.settings['address_street'] && this.settings['address_number'] && this.settings['address_zipcode'] && this.settings['address_city'] && this.settings['address_province'] && this.settings['address_country'])
            },
        },

        methods: {

            localizePosition() {
                if(this.canLocalize) {
                    let params = {
                        'address_street': this.settings['address_street'],
                        'address_number': this.settings['address_number'],
                        'address_zipcode': this.settings['address_zipcode'],
                        'address_city': this.settings['address_city'],
                        'address_province': this.settings['address_province'],
                        'address_country': this.settings['address_country'],
                    }
                    this.axios.post('settings/localize', params).then(response => {
                        if(response.data.data) {
                            let coordinate = response.data.data
                            this.$set(this.settings, 'address_lat', coordinate.address_lat)
                            this.$set(this.settings, 'address_lng', coordinate.address_lng)
                        }
    
                    }, response => {
                        // error callback
                    })
                }
            }
        }

    }
</script>